import { produce } from 'immer';
import {
  doLoadPlans,
  doPlanUnsetPin,
  doUnloadPlans,
  doPlansSetPlan,
  doPlansSetSelectedPinId,
  doPlansUpdatePin,
  eventAssetDataUpdated,
} from 'store/actions';
import { SIGN_OUT } from 'store/auth/actions';
import { AppContextEnum } from 'types/types';
import { createReducer } from 'typesafe-actions';

import { Plan, PlanState } from './types';

const initialState: PlanState = {
  data: undefined,
};

export const planReducer = createReducer(initialState)
  .handleAction(SIGN_OUT.success, () => initialState)
  .handleAction(doLoadPlans, (state, action) => ({
    ...state,
    data: {
      context: action.payload.context,

      plansEditable: action.payload.plansEditable,
      findNoun: action.payload.findNoun,
      selectionKey: action.payload.selectionKey,
      actionAfterFind: action.payload.actionAfterFind,

      plans: action.payload.plans,
      pin: action.payload.pin,
      initPin: action.payload.pin,
      pins: action.payload.pins,

      plan: undefined,
      selectedPinId: undefined,
    },
  }))
  .handleAction(doPlansSetPlan, (state, action) =>
    state.data
      ? {
          ...state,
          data: {
            ...state.data,
            selectedPinId: undefined,
            plan: action.payload.plan,
          },
        }
      : state,
  )
  .handleAction(doPlansUpdatePin, (state, action) =>
    state.data
      ? {
          ...state,
          data: {
            ...state.data,
            pin: {
              planId: action.payload.planId,
              x: action.payload.x,
              y: action.payload.y,
            },
          },
        }
      : state,
  )
  .handleAction(doPlanUnsetPin, (state) =>
    state.data
      ? {
          ...state,
          data: {
            ...state.data,
            pin: undefined,
          },
        }
      : state,
  )
  .handleAction(doPlansSetSelectedPinId, (state, action) =>
    state.data
      ? {
          ...state.data,
          data: { ...state.data, selectedPinId: action.payload },
        }
      : state,
  )
  .handleAction(doUnloadPlans, (state) => ({ ...state, data: undefined }))

  .handleAction(eventAssetDataUpdated, (state, action) =>
    produce(state, (draft) => {
      if (
        draft.data &&
        (draft.data.context.context === AppContextEnum.localAsset ||
          draft.data.context.context === AppContextEnum.localAssessment) &&
        draft.data.context.assetId === action.payload.assetId
      ) {
        if (action.payload.updatedKeys.includes('plans')) {
          draft.data.plans = Object.entries(action.payload.data.plans).reduce<
            Record<string, Plan>
          >((acc, [planId, plan]) => {
            if (plan) {
              acc[planId] = {
                id: plan.id,
                name: plan.name,
                fileId: plan.fileId,
                filePage: plan.filePage || 0,
                fileType: plan.fileType || 'image',
                fileWidth: plan.fileWidth || 0,
                fileHeight: plan.fileHeight || 0,
                pinCount: plan.pinCount,
              };
            }
            return acc;
          }, {});
        }
      }
    }),
  );
